// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalNext_modal__2a95T","modalLayout":"ModalNext_modalLayout__UBPRZ","overlay":"ModalNext_overlay__zAQ_q"};